import { useQueries } from "@tanstack/react-query";
import { useMemo } from "react";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../../consts/api";
import { http } from "../../../../../../services/HttpService";

function pairKey(clinicId, providerId) {
  return `${clinicId}:${providerId}`;
}

/**
 * BoomRX is scoped to a clinic AND its onboarded prescriber (setup_providers) —
 * a clinic being enabled is not enough, the procedure's provider must also be
 * an onboarded BoomRX prescriber for that clinic.
 */
export function useBoomrxStatusByClinicAndProvider(pairs) {
  const uniquePairs = useMemo(() => {
    const seen = new Set();
    const out = [];
    (pairs || []).forEach(({ clinicId, providerId }) => {
      if (!clinicId || !providerId) {
        return;
      }
      const key = pairKey(clinicId, providerId);
      if (seen.has(key)) {
        return;
      }
      seen.add(key);
      out.push({ clinicId, providerId });
    });
    return out;
  }, [pairs]);

  const results = useQueries({
    queries: uniquePairs.map(({ clinicId, providerId }) => ({
      queryKey: [QUERY_KEYS.boomrx.status, clinicId, providerId],
      queryFn: async () => {
        const res = await http.get(HTTP_ENDPOINTS.boomrx.status(), {
          params: { clinicId, providerId },
        });
        return res?.data?.data?.enabled === true;
      },
      staleTime: 5 * 60 * 1000,
    })),
  });

  return useMemo(() => {
    const map = {};
    uniquePairs.forEach(({ clinicId, providerId }, i) => {
      map[pairKey(clinicId, providerId)] = results[i]?.data === true;
    });
    return map;
  }, [uniquePairs, results]);
}

export function boomrxStatusKey(clinicId, providerId) {
  return pairKey(clinicId, providerId);
}
